var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 149,
    viewBox: "0 0 150 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9998 12.4167C40.7298 12.4167 12.9165 40.23 12.9165 74.5C12.9165 108.77 40.7298 136.583 74.9998 136.583C109.27 136.583 137.083 108.77 137.083 74.5C137.083 40.23 109.27 12.4167 74.9998 12.4167ZM74.9998 124.167C47.6211 124.167 25.3332 101.879 25.3332 74.5C25.3332 47.1213 47.6211 24.8334 74.9998 24.8334C102.379 24.8334 124.666 47.1213 124.666 74.5C124.666 101.879 102.379 124.167 74.9998 124.167ZM103.496 47.0592L62.5832 87.9721L46.5036 71.9546L37.7498 80.7084L62.5832 105.542L112.25 55.875L103.496 47.0592Z",
    fill: "#05CD99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.201c9c4d3424f0113c5d716a996dd605.svg";
export { ForwardRef as ReactComponent };